import { render, staticRenderFns } from "./importDwSpuId.vue?vue&type=template&id=19deaaca&scoped=true"
import script from "./importDwSpuId.vue?vue&type=script&lang=js"
export * from "./importDwSpuId.vue?vue&type=script&lang=js"
import style0 from "./importDwSpuId.vue?vue&type=style&index=0&id=19deaaca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19deaaca",
  null
  
)

export default component.exports